import { __decorate } from "tslib";
import { attr, observable, volatile } from '@microsoft/fast-element';
import { FoundationElement } from '@microsoft/fast-foundation';
import dialogPolyfill from 'dialog-polyfill';
import { logger } from '../utils';
import { foundationDialogStyles as styles } from './dialog.styles';
import { foundationDialogTemplate as template } from './dialog.template';
// explicitly declaring for extensibility
export const foundationDialogShadowOptions = {
    mode: 'open',
    delegatesFocus: true,
};
export const defaultDialogConfig = {};
export class DialogElement extends FoundationElement {
    constructor() {
        super(...arguments);
        this.position = 'centre';
        /**
         * Whether or not to show the close icon
         */
        this.showCloseIcon = true;
    }
    notificationChanged() {
        if (this.notification)
            this.showCloseIcon = false;
    }
    connectedCallback() {
        super.connectedCallback();
        if (!window['HTMLDialogElement']) {
            dialogPolyfill.registerDialog(this.mainElement);
        }
        this.mainElement.addEventListener('close', () => {
            if (this.onCloseCallback)
                this.onCloseCallback();
        });
    }
    /**
     * Determine if the dialog is showing or closed.
     */
    get open() {
        return this.mainElement.hasAttribute('open');
    }
    /**
     * Remove the HTMLDialogElement from display
     */
    close() {
        this.mainElement['close']();
    }
    /**
     * Dismiss the Dialog from display and calls the dismissing action.
     */
    dismiss() {
        var _a, _b, _c, _d;
        if ((_d = (_c = (_b = (_a = this.notification) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.dialog) === null || _c === void 0 ? void 0 : _c.dismissingAction) === null || _d === void 0 ? void 0 : _d.action) {
            this.notification.config.dialog.dismissingAction.action();
        }
        this.closeDialog();
    }
    /**
     * Dismiss the Dialog from display.
     */
    closeDialog() {
        try {
            this.mainElement.close();
            this.remove();
        }
        catch (e) {
            logger.error(e);
        }
    }
}
__decorate([
    observable
], DialogElement.prototype, "notification", void 0);
__decorate([
    attr
], DialogElement.prototype, "position", void 0);
__decorate([
    attr({ mode: 'boolean', attribute: 'show-close-icon' })
], DialogElement.prototype, "showCloseIcon", void 0);
__decorate([
    observable
], DialogElement.prototype, "onShowCallback", void 0);
__decorate([
    observable
], DialogElement.prototype, "onCloseCallback", void 0);
__decorate([
    volatile
], DialogElement.prototype, "open", null);
/**
 * @tagname %%prefix%%-dialog
 */
export class Dialog extends DialogElement {
    show() {
        if (this.onShowCallback)
            this.onShowCallback();
        this.mainElement['show']();
    }
}
/**
 * The Foundation Dialog
 *
 * @public
 * @remarks
 * HTML Element: \<foundation-dialog\>
 */
export const foundationDialog = Dialog.compose(Object.assign({ baseName: 'dialog', styles,
    template, shadowOptions: foundationDialogShadowOptions }, defaultDialogConfig));
